import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AppStateService } from 'core/app-state/app-state.service';
import { AuthenticationService } from 'core/authentication/authentication.service';
import { ResponseType } from '../api/response-type.enum';

@Injectable()
export class LoggerService {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private appStateService: AppStateService
  ) { }

  /**
   * Logs an error message to the server
   * @param errorMessage - The message
   */
  logError(errorMessage: string) {
    return this.log(errorMessage, '/api/log/error');
  }

  /**
   * Logs an info message to the server
   * @param infoMessage - The message
   */
  logInfo(infoMessage: string) {
    return this.log(infoMessage, '/api/log/info');
  }

  private log(message: string, endpoint: string) {
    const reqUrl = '';
    const token = this.authenticationService.getToken();

    if (!token) {
      return;
    }

    const httpOptions = {
      headers: new HttpHeaders(
        {
          Authorization: token,
          'Response-Type': ResponseType.JSON
        })
    };

    const payload = {
      url: reqUrl,
      actionMessage: message
    };

    if (this.appStateService.state.isOnline) {
      endpoint = environment.webRoot + endpoint;
    } else {
      endpoint = environment.offlineApiRoot + endpoint;
    }

    return this.http.post(endpoint, payload, httpOptions).subscribe();
  }
}
